"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityLite = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Query for a lightweight entry based on its `slug` and `contentType`
 *
 * @param {object} query - Query parameters
 * @param {string} query.id - The `id` for the entry
 * @param {string} query.contentType - The `contentType` for the entry
 * @return {object} Contentful query
 */
// eslint-disable-next-line import/prefer-default-export
var entityLite = function entityLite(_ref) {
  var id = _ref.id,
    contentType = _ref.contentType;
  var selectFields = {
    helpPost: ['slug', 'site'],
    journey: ['slug', 'site'],
    productPage: ['slug', 'category', 'subCategory', 'site'],
    page: ['slug', 'parent', 'subLevel', 'site'],
    page_v2: ['slug', 'parent', 'subLevel', 'site', 'pageType'],
    topicPage: ['slug', 'parent', 'site'],
    resultCard: ['type'],
    triagePage: ['slug']
  };
  return {
    content_type: contentType,
    'sys.id': id,
    select: [].concat(_toConsumableArray((selectFields[contentType] || []).map(function (field) {
      return "fields.".concat(field);
    })), ['sys.contentType'])
  };
};
exports.entityLite = entityLite;